export const CLOSE_SUCCESS_MODAL = 'CLOSE_SUCCESS_MODAL';
export const OPEN_SUCCESS_MODAL = 'OPEN_SUCCESS_MODAL';
export const ADD_MESSAGE_MODAL = 'ADD_MESSAGE_MODAL';
export const ADD_TITLE_MODAL = 'ADD_TITLE_MODAL';
export const ADD_TEXT_BUTTON_MODAL = 'ADD_TEXT_BUTTON_MODAL';

export function closeSuccessModal() {
  return {
    type: CLOSE_SUCCESS_MODAL
  };
}

export function openSuccessModal() {
  return {
    type: OPEN_SUCCESS_MODAL
  };
}

export function addMessageModal(message) {
  return {
    type: ADD_MESSAGE_MODAL,
    payload: message
  };
}

export function addTitleModal(title) {
  return {
    type: ADD_TITLE_MODAL,
    payload: title
  };
}

export function addTextButtonModal(text) {
  return {
    type: ADD_TEXT_BUTTON_MODAL,
    payload: text
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/modalActions.js